import { c as _c } from "react/compiler-runtime";
import React, { useEffect, useRef } from 'react';
import { PageTab } from 'shared/components/page-tab/page-tab';
import { PageTabGroup } from 'shared/components/page-tab/page-tab-group';
import { PageTabList } from 'shared/components/page-tab/page-tab-list';
import { twJoin } from 'tailwind-merge';
export type ItemTabType<T> = {
  key: T;
  caption: string;
  hasError: boolean;
};
interface ItemTabsProps<T extends string> {
  tabs: ItemTabType<T>[];
  currentTab: T;
  setTab: (tab: T) => void;
}
const ItemTabs = t0 => {
  const $ = _c(20);
  const {
    tabs,
    currentTab,
    setTab
  } = t0;
  const ref = useRef(null);
  let t1;
  if ($[0] !== tabs) {
    t1 = tabs.some(_temp);
    $[0] = tabs;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const hasErrors = t1;
  let t2;
  let t3;
  if ($[2] !== hasErrors) {
    t2 = () => {
      if (!hasErrors) {
        return;
      }
      if (!ref.current) {
        return;
      }
      ref.current.style.scrollMarginTop = "20px";
      ref.current.scrollIntoView({
        behavior: "smooth"
      });
    };
    t3 = [hasErrors];
    $[2] = hasErrors;
    $[3] = t2;
    $[4] = t3;
  } else {
    t2 = $[3];
    t3 = $[4];
  }
  useEffect(t2, t3);
  let t4;
  if ($[5] !== currentTab || $[6] !== tabs) {
    let t5;
    if ($[8] !== currentTab) {
      t5 = el => el.key === currentTab;
      $[8] = currentTab;
      $[9] = t5;
    } else {
      t5 = $[9];
    }
    t4 = tabs.findIndex(t5);
    $[5] = currentTab;
    $[6] = tabs;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[10] !== setTab || $[11] !== tabs) {
    let t6;
    if ($[13] !== setTab) {
      t6 = tab_0 => <PageTab key={tab_0.key} className={twJoin("pb-3 pt-0", tab_0.hasError && "text-danger")} onClick={() => setTab(tab_0.key)}>{tab_0.caption}</PageTab>;
      $[13] = setTab;
      $[14] = t6;
    } else {
      t6 = $[14];
    }
    t5 = tabs.map(t6);
    $[10] = setTab;
    $[11] = tabs;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  let t6;
  if ($[15] !== t5) {
    t6 = <PageTabList className="w-auto translate-x-0 px-0 sm:translate-x-0 sm:px-0 md:translate-x-0 md:px-0">{t5}</PageTabList>;
    $[15] = t5;
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  let t7;
  if ($[17] !== t4 || $[18] !== t6) {
    t7 = <div ref={ref}><PageTabGroup selectedIndex={t4}>{t6}</PageTabGroup></div>;
    $[17] = t4;
    $[18] = t6;
    $[19] = t7;
  } else {
    t7 = $[19];
  }
  return t7;
};
export default ItemTabs;
function _temp(tab) {
  return tab.hasError;
}